import { GameSelectionButton } from "../navigation/game-selection-button";
import React, { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { loadGames, loadProfile } from "../game-state/games.functions";
import { useNavigate } from "react-router-dom";
import { selectCategoryScoreFactory } from "../game-state/user-profile.slice";

export const Overview = () => {
  const games = useAppSelector((state) => state.gameOverviewState.games);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(loadProfile());
    dispatch(loadGames());
  }, [dispatch]);

  return (
    <>
      {games.allCategories.map((category) => (
        <CategoryCard key={category} category={category} />
      ))}
    </>
  );
};

export const CategoryCard = ({ category }: { category: string }) => {
  const games = useAppSelector((state) => state.gameOverviewState.games);
  const beta = useAppSelector((state) => state.userProfileState.beta);
  const navigate = useNavigate();

  const calculatedScore = useAppSelector(
    useMemo(
      () => selectCategoryScoreFactory(games.categories[category]),
      [games, category]
    )
  );

  return (
    <div className="container mx-auto">
      <div className="food mx-auto max-w-4xl my-8 sm:my-16 xs:rounded shadow-xl overflow-hidden">
        <div className="w-full flex justify-between items-center text-2xl font-extrabold text-blue-600 bg-white px-6 py-4">
          <h1 className="">{category}</h1>
          <div className="flex justify-end flex-wrap gap-4">
            <div className="text-yellow-700 transition transform hover:scale-110 hover:-translate-y-1 duration-300">
              <span className="mr-1">{calculatedScore.bad}</span>
              <i className="fa fa-poo" />
            </div>
            <div className="text-gray-400 transition transform hover:scale-110 hover:-translate-y-1 duration-300">
              <span className="mr-1">{calculatedScore.good}</span>
              <i className="fas fa-medal" />
            </div>
            <div className="text-yellow-500 transition transform hover:scale-110 hover:-translate-y-1 duration-300">
              <span className="mr-1">{calculatedScore.perfect}</span>
              <i className="fa fa-trophy" />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 p-6">
          {games.categories[category]
            .filter((id) => (beta ? true : !games.byId[id].beta))
            .map((id) => (
              <div key={id}>
                <GameSelectionButton
                  gameId={id}
                  game={games.byId[id]}
                  onClick={() => {
                    navigate(`games/${id}`);
                  }}
                />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
